import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logodapur from '../img/logodapursidebar.png'
import arrow from '../img/arrow1.png'
import { ReactComponent as DashboardIcon } from '../img/dashboardicon.svg'
import { ReactComponent as ManajemenPenggunaIcon } from '../img/manajemenpenggunaicon.svg'
import { ReactComponent as MenuMingguanIcon } from '../img/menumingguanicon.svg'
// import { ReactComponent as ManajemenStokIcon } from '../img/manajemenstokicon.svg'
// import { ReactComponent as LaporanIcon } from '../img/laporanicon.svg'
// import { ReactComponent as PengaturanIcon } from '../img/pengaturanicon.svg'
import { ReactComponent as InputDataIcon } from '../img/inputdataicon.svg'
//import { ReactComponent as DaftarPemasokIcon } from '../img/daftarpemasokicon.svg'
import { ReactComponent as PesananIcon } from '../img/pesananicon.svg'
// import { ReactComponent as MenuHarianIcon } from '../img/menuharianicon.svg'
import { ReactComponent as LaporanProduksiIcon } from '../img/laporanproduksiicon.svg'
import { ReactComponent as StockIcon } from '../img/stockicon.svg'
import { ReactComponent as PenerimaanBahan } from '../img/penerimaanbahanicon.svg'
import { ReactComponent as PlusIcon } from "../img/plusicon.svg";
import { StarIcon } from '@heroicons/react/24/solid';

import {
  // HomeIcon,
  // UserIcon,
  // Cog6ToothIcon,
  // ArrowLeftOnRectangleIcon,
  Bars3Icon,
} from '@heroicons/react/24/outline';
import { useLocation } from "react-router-dom";

export default function CollapsingSidebar() {
  const [isCollapsed, setIsCollapsed] = useState(false); // Collapse state
  const [isMobileOpen, setIsMobileOpen] = useState(false); // Mobile sidebar open state
  const [isRotated, setIsRotated] = useState(false); // For rotating the arrow icon

  const navigate = useNavigate();
  const location = useLocation(); // Get the current route
  const [selectedItem, setSelectedItem] = useState(""); // Selected item state


  const roleId = parseInt(localStorage.getItem('roleId'),10); 

const isDraftOrderActive = location.pathname === "/draftOrder"; // query-safe
const currentPath = location.pathname; // e.g. "/draftOrder"

  useEffect(() => {
    // Sync selected item with the current route
    const pathToLabel = {
      "/": "Dashboard",
      "/inputdata": "Master Data",
      "/manajemenpengguna": "Manajemen Pengguna",
      "/dapurtable": "Manajemen Pengguna",
      "/menumingguan": roleId === 4 ? "Daftar Menu Mingguan" : "Menu Mingguan",
      "/manajemenstok": "Manajemen Stok",
      "/laporan": "Laporan",
      "/settings": "Pengaturan",
      "/ingredientstable": "Master Data",
      "/ingredientscategorytable": "Master Data",
      "/editpemasok": "Master Data",
      "/inputmenu": "Master Data",
      "/inputdapur": "Manajemen Pengguna",
      "/inputkoperasi": "Manajemen Pengguna",
      // "/inputlocation": "Manajemen Pengguna",
      "/locationtable": "Manajemen Pengguna",
      "/manajemenuploadharga": "Master Data",
      "/lihatpemasok": "Master Data",
      "/manajemenuploadhargadetail" : "Master Data",
      "/detailuploadtable": "Master Data",
      "/uploadharga": "Master Data",
      "/tambahpemasok": "Master Data",
      "/daftarharilibur": "Master Data",
      "/daftarpemasok": "Daftar Pemasok",
      "/daftarpesanan": "Pemesanan",
      "/daftarpemesanan": "Pemesanan",
      "/draftOrder/": "Pemesanan",
      "/purchaseorder": "Purchase Order",
      "/daftarPO": "daftar Purchase Order",
      "/menuharian": "Menu Harian",
      "/penerimaanbahan": "Penerimaan Bahan",
      "/tabeljadwalcustomer": "Rencana dan Laporan Produksi",
      "/jadwalcustomer": "Rencana dan Laporan Produksi",
      "/tambahhasilproduksi": "Laporan Produksi",
      "/penerimaanPO": "Pemesanan",
      "/penerimaanPO/": "Pemesanan",
      "/penerimaanbahanDapur": "Penerimaan Bahan",
      "/daftarStock": "Stok",
      "/daftarStockDapur/": "Stok Dapur",
      "/daftarStock/": "Stok",
      "/daftarDO": "Daftar DO",
      "/daftarmenumingguan": "Daftar Menu Mingguan",
      "/daftarkonsumen": "Daftar Konsumen",
      "/tambahkonsumen": "Daftar Konsumen",
      "/ordertambahan": "Order Manual",
      "/tabellaporanproduksi": "Laporan Produksi",
      "/tambahmenu": "Master Data",
      "/uploadresep": "Master Data",
      "/editharilibur": "Master Data",
      "/tambahdapur": "Master Data",
      "/tambahharilibur": "Master Data",
      "/weeklyreport": "Laporan Produksi",
      "/monthlyreport": "Laporan Produksi",
      "/ratingpelanggan": "Rating Penerima Manfaat",
      "/weeklyreports": "Laporan Periodik",
    };

    setSelectedItem(pathToLabel[location.pathname] || "Dashboard");
  }, [location.pathname, roleId]); // Re-run when location changes

  const toggleSidebar = () => {
    setIsCollapsed((prev) => !prev); // Toggle the collapse state
  };

  const toggleMobileSidebar = () => {
    setIsMobileOpen(!isMobileOpen); // Toggle mobile sidebar visibility
  };

  const toggleRotation = () => {
    setIsRotated((prev) => !prev); // Toggle the arrow rotation
  };

  const handleButtonClick = () => {
    toggleSidebar();
    toggleRotation();
  };

  const handleNavigate = (path, label) => {
    setSelectedItem(label); // Set the selected item
    navigate(path);
  };
  const localDateString = (thedate) =>{

    const year = thedate.getFullYear();
    const month = String(thedate.getMonth() + 1).padStart(2, '0');  // Adding 1 because months are 0-based
    const day = String(thedate.getDate()).padStart(2, '0');
    
  // console.log("startDate", thedate);
  const localDateString = `${year}-${month}-${day}`;
  
  return localDateString
  
  }
    
  const today = new Date();
  
  return (
    <div className="relative z-20 flex" style={{ boxShadow: "10px 0 15px -3px rgba(0, 0, 0, 0.1)" }}>
      {/* Mobile Toggle Button */}
      <button
        onClick={toggleMobileSidebar}
        className="md:hidden text-gray-500 p-2 bg-white hover:bg-[#FFA101] hover:text-white focus:outline-none fixed top-4 left-4 z-30 rounded-full shadow-lg"
      >
        <Bars3Icon className="h-6 w-6" />
      </button>

      {/* Sidebar */}
      <div
        className={`fixed md:relative top-0 left-0 bg-white text-white h-full p-5 pt-8 z-20 transition-all duration-300 ease-in-out flex flex-col ${
          isMobileOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0 ${isCollapsed ? "w-20" : "w-64 overflow-y-auto overflow-x-hidden"}`} // Apply width based on collapse state
      >
        {/* Top Section */}
        <div className="md:flex items-center h-16 mb-4">
          <span className="text-lg font-bold">
            <img src={logodapur} alt="Logo" />
          </span>
          {/* On mobile, remove the arrow button */}
          <button
            className={`absolute right-[-10px] top-14 focus:outline-none rounded-full hidden md:block ${isCollapsed ?" right-[-20px]" : " right-[-10px]"}`}
            onClick={handleButtonClick}
            style={{ padding: 0 }}
          >
            <img
              src={arrow}
              alt="Arrow Icon"
              className={`h-12 w-12 object-contain transition-transform duration-300 ${isRotated ? "rotate-180" : ""}`}
            />
          </button>
        </div>

        {/* Menu Items */}
        <div className="flex-grow mt-10 text-gray-500">
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<DashboardIcon className="h-6 w-6" />}
            label="Dashboard"
            isSelected={currentPath === "/"}
            onClick={() => {
              handleNavigate("/", "Dashboard");
              isMobileOpen && toggleMobileSidebar();
            }}
            path="/"
          />
      
          
        {roleId === 2 || roleId === 4 || roleId === 5 ? (
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<InputDataIcon className="h-6 w-6" />}
            label="Master Data"
            isSelected={selectedItem === "Master Data"}
            onClick={(path, label) => {
              handleNavigate(path, label);
              if (isMobileOpen) toggleMobileSidebar();
            }}
            
            path="/inputdata"
            subItems={[
              // { label: "Input Data", path: "/inputdata" },
              // { label: "Tambah Data Lokasi", path: "/inputlocation" },
              { label: "Daftar Dapur", path: "/inputdapur", matchPaths: ["/inputdapur", "/tambahdapur"] },
              { label: "Daftar Pemasok", path: "/daftarpemasok", matchPaths: ["/daftarpemasok", "/tambahpemasok"] },
              { label: "Daftar Makanan", path: "/inputmenu", matchPaths: ["/inputmenu", "/tambahmenu", "/uploadresep"]  },
              { label: "Daftar Bahan Baku", path: "/ingredientstable", matchPaths: ["/ingredientstable", "/inputdata"] },
              //{ label: "Daftar Kategori Bahan Baku", path: "/ingredientscategorytable" },
              // { label: "Detail Upload Table", path: "/detailuploadtable" },
              // { label: "Upload csv", path: "/csvpage" },
              { label: "Daftar Hari Libur", path: "/daftarharilibur", matchPaths: ["/daftarharilibur", "/editharilibur", "/tambahharilibur"] },
              { label: "Daftar Upload Harga", path: "/manajemenuploadharga", matchPaths: ["/manajemenuploadharga", "/uploadharga"] },
            ]}
          />) : ("")}

          {roleId === 6 ? (
            <div>
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<InputDataIcon className="h-6 w-6" />}
            label="Master Data"
            isSelected={selectedItem === "Master Data"}
            onClick={(path, label) => {
              handleNavigate(path, label);
              if (isMobileOpen) toggleMobileSidebar();
            }}
            
            path="/inputdata"
            subItems={[
              { label: "Daftar Upload Harga", path: "/manajemenuploadharga", matchPaths: ["/manajemenuploadharga", "/uploadharga"] },
            ]}
          />
          
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<StarIcon className="h-6 w-6" />}
            label="Rating Supplier"
            isSelected={currentPath === "/ratingsupplier"}
            onClick={() => {
              handleNavigate("/ratingsupplier", "Rating Supplier");
              isMobileOpen && toggleMobileSidebar();
            }}
            path="/"
          />
          </div>
          ) : ("")}

          
        {/* {roleId === 5? (
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<InputDataIcon className="h-6 w-6" />}
            label="Master Data"
            isSelected={selectedItem === "Master Data"}
            onClick={(path, label) => {
              handleNavigate(path, label);
              if (isMobileOpen) toggleMobileSidebar();
            }}
            path="/inputdata"
            subItems={[
              // { label: "Input Data", path: "/inputdata" },
              // { label: "Tambah Data Lokasi", path: "/inputlocation" },
              // { label: "Daftar Koperasi", path: "/inputkoperasi" },
              { label: "Daftar Makanan", path: "/inputmenu", matchPaths: ["/inputmenu", "/tambahmenu", "/uploadresep"]  },
              { label: "Daftar Bahan Baku", path: "/ingredientstable", matchPaths: ["/ingredientstable", "/inputdata"] },
              // { label: "Detail Upload Table", path: "/detailuploadtable" },
              // { label: "Upload csv", path: "/csvpage" },
              { label: "Daftar Hari Libur", path: "/daftarharilibur", matchPaths: ["/daftarharilibur", "/editharilibur", "/tambahharilibur"] },
            ]}
          />) : ("")} */}
          
          {roleId === 1 ? (
            <div>
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<ManajemenPenggunaIcon className="h-6 w-6" />}
            label="Manajemen Pengguna"
            isSelected={selectedItem === "Manajemen Pengguna"}
            onClick={(path, label) => {
              handleNavigate(path, label);
              if (isMobileOpen) toggleMobileSidebar();
            }}
            path="/manajemenpengguna"
            subItems={[
              { label: "Admin", path: "/manajemenpengguna" },
              { label: "Daftar Dapur", path: "/inputdapur", matchPaths: ["/inputdapur", "/tambahdapur"] },
              { label: "Daftar Koperasi", path: "/locationtable" },
              // { label: "Daftar Dapur", path: "/dapurtable" },
            ]}
          /> 
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<InputDataIcon className="h-6 w-6" />}
            label="Master Data"
            isSelected={selectedItem === "Master Data"}
            onClick={(path, label) => {
              handleNavigate(path, label);
              if (isMobileOpen) toggleMobileSidebar();
            }}
            
            path="/inputdata"
            subItems={[
              // { label: "Input Data", path: "/inputdata" },
              // { label: "Tambah Data Lokasi", path: "/inputlocation" },
             // { label: "Daftar Dapur", path: "/inputdapur", matchPaths: ["/inputdapur", "/tambahdapur"] },
             // { label: "Daftar Pemasok", path: "/daftarpemasok", matchPaths: ["/daftarpemasok", "/tambahpemasok"] },
              //{ label: "Daftar Makanan", path: "/inputmenu", matchPaths: ["/inputmenu", "/tambahmenu", "/uploadresep"]  },
              { label: "Daftar Bahan Baku", path: "/ingredientstable", matchPaths: ["/ingredientstable", "/inputdata"] },
              //{ label: "Daftar Kategori Bahan Baku", path: "/ingredientscategorytable" },
              // { label: "Detail Upload Table", path: "/detailuploadtable" },
              // { label: "Upload csv", path: "/csvpage" },
             // { label: "Daftar Hari Libur", path: "/daftarharilibur", matchPaths: ["/daftarharilibur", "/editharilibur", "/tambahharilibur"] },
             // { label: "Daftar Upload Harga", path: "/manajemenuploadharga", matchPaths: ["/manajemenuploadharga", "/uploadharga"] },
            ]}
          />
          </div>
          ): ("")}
          
          { roleId === 4 ? (
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<MenuMingguanIcon className="h-6 w-6" />}
            label="Daftar Menu Mingguan"
            isSelected={selectedItem === "Daftar Menu Mingguan"}
            onClick={() => {handleNavigate("/daftarmenumingguan", "Daftar Menu Mingguan");
              isMobileOpen && toggleMobileSidebar();}}
            path="/daftarmenumingguan"
          /> ): ("")}

          {roleId === 2 || roleId === 3 || roleId === 5 ? (
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<MenuMingguanIcon className="h-6 w-6" />}
            label="Menu Mingguan"
            isSelected={selectedItem === "Menu Mingguan"}
            onClick={() => {handleNavigate("/menumingguan", "Menu Mingguan");
              isMobileOpen && toggleMobileSidebar();}}
            path="/menumingguan"
          /> ): ("")}
          {/* {roleId === 2 || roleId === 3 ? (
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<ManajemenStokIcon className="h-6 w-6" />}
            label="Manajemen Stok"
            isSelected={selectedItem === "Manajemen Stok"}
            onClick={() => handleNavigate("/manajemenstok", "Manajemen Stok")}
            path="/manajemenstok"
            /> ): ("")}
          {roleId === 2 || roleId === 3 ? 
          (
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<LaporanIcon className="h-6 w-6" />}
            label="Laporan"
            isSelected={selectedItem === "Laporan"}
            onClick={() => handleNavigate("/laporan", "Laporan")}
            path="/laporan"
            /> ): ("")
            } */}
          {/* <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<DaftarPemasokIcon className="h-6 w-6" />}
            label="Daftar Pemasok"
            isSelected={selectedItem === "Daftar Pemasok"}
            onClick={() => handleNavigate("/daftarpemasok", "Daftar Pemasok")}
            path="/daftarpemasok"
          /> */}
          {roleId === 2 || roleId === 4  || roleId === 3? (
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<PesananIcon className="h-6 w-6" />}
            label="Pemesanan"
            isSelected={selectedItem === "Pemesanan"}
            onClick={(path, label) => {
              handleNavigate(path, label);
              if (isMobileOpen) toggleMobileSidebar();
            }}
            path="/daftarpesanan"
            subItems={[
              { label: "Draft Pesanan", path: "/draftOrder/", matchPaths: ["/draftOrder/", "/penerimaanPO/" ] },
              { label: "Purchase Order", path: "/daftarPO", matchPaths: ["/daftarPO", "/daftarpemesanan", "/penerimaanPO"] },
              // { label: "Delivery Order", path: "/daftarDO" }
              //wew
              // { label: "Penerimaan PO", path: "/penerimaanPO" },
              // { label: "Penerimaan Bahan Dapur", path: "/penerimaanbahandapur" },
            ]}
          />) : ("")}

          
          {roleId === 5 ? (
            <div>
          <SidebarItem
  isCollapsed={isCollapsed}
  icon={<PesananIcon className="h-6 w-6" />}
  label="Pemesanan"
  isSelected={currentPath.startsWith("/draftOrder")}  // highlight for /draftOrder + query
  onClick={() => {
    handleNavigate("/draftOrder", "Pemesanan");
    isMobileOpen && toggleMobileSidebar();
  }}
  path="/draftOrder"
/>
{/*         
        <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<LaporanProduksiIcon className="h-6 w-6" />}
            label="Laporan Produksi"
            isSelected={selectedItem === "Laporan Produksi"}
            onClick={() => {handleNavigate(`/tabellaporanproduksi`, "Laporan Produksi");
              isMobileOpen && toggleMobileSidebar();}}
            path="/"
          /> */}
        </div>
        ) : ("")}
          {/* {roleId === 2 || roleId === 3 ? (
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<MenuHarianIcon className="h-6 w-6" />}
            label="Menu Harian"
            isSelected={selectedItem === "Menu Harian"}
            onClick={() => handleNavigate("/menuharian", "Menu Harian")}
            path="/menuharian"
            /> ): ("")} */}
           
           {roleId === 4 ? (
            <div>
          
            <SidebarItem
              isCollapsed={isCollapsed} // Use collapse state on desktop
              icon={<LaporanProduksiIcon className="h-6 w-6" />}
              label="Rencana dan Laporan Produksi"
              isSelected={selectedItem === "Rencana dan Laporan Produksi"}
              onClick={() => {handleNavigate(`/tabeljadwalcustomer`, "Rencana dan Laporan Produksi");
                isMobileOpen && toggleMobileSidebar();}}
              path="/"
            />
            
            <SidebarItem
                isCollapsed={isCollapsed} // Use collapse state on desktop
                icon={<StockIcon className="h-6 w-6" />}
                label="Stok"
                isSelected={selectedItem === "Stok"}
                onClick={(path, label) => {
                  handleNavigate(path, label);
                  if (isMobileOpen) toggleMobileSidebar();
                }}
                path="/"
                subItems={[
                  { label: "Stok Bahan Baku", path: "/daftarStock/" },
                  // { label: "Stock Dapur", path: "/daftarStockDapur/" }
                ]}
              />
                
                
            </div>
        ) : ( ""
          // <SidebarItem
          //     isCollapsed={isCollapsed} // Use collapse state on desktop
          //     icon={<StockIcon className="h-6 w-6" />}
          //     label="Stok"
          //     isSelected={selectedItem === "Stok"}
          //     onClick={() => {handleNavigate("/daftarStock/", "Stok");
          //       isMobileOpen && toggleMobileSidebar();}}
          //     path="/"
          //   />
            )}
          {roleId === 2 ? (
            <div>
          
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<LaporanProduksiIcon className="h-6 w-6" />}
            label="Laporan Produksi"
            isSelected={selectedItem === "Laporan Produksi"}
            onClick={() => {handleNavigate(`/tabellaporanproduksi`, "Laporan Produksi");
              isMobileOpen && toggleMobileSidebar();}}
            path="/"
          />
          
          
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<PenerimaanBahan className="h-6 w-6" />}
            label="Penerimaan Bahan"
            isSelected={selectedItem === "Penerimaan Bahan"}
            onClick={() => {handleNavigate(`/penerimaanbahan?startDate=${localDateString(today)}&endDate=${localDateString(today)}`, "Penerimaan Bahan");
            isMobileOpen && toggleMobileSidebar();}}
            path="/"
          />
          
            <SidebarItem
              isCollapsed={isCollapsed} // Use collapse state on desktop
              icon={<StockIcon className="h-6 w-6" />}
              label="Stok"
              isSelected={selectedItem === "Stok"}
              onClick={() => {handleNavigate("/daftarStock", "Stok");
                isMobileOpen && toggleMobileSidebar();}}
              path="/"
            />
          </div>
          ) : (
              roleId === 3 || roleId === 5? (
              
          <div>
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<ManajemenPenggunaIcon className="h-6 w-6" />}
            label="Daftar Konsumen"
            isSelected={selectedItem === "Daftar Konsumen"}
            onClick={() => {handleNavigate(`/daftarkonsumen`, "Daftar Konsumen");
              isMobileOpen && toggleMobileSidebar();}}
            path="/"
          />
          {/* <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<LaporanProduksiIcon className="h-6 w-6" />}
            label="Laporan Produksi"
            isSelected={selectedItem === "Laporan Produksi"}
            onClick={() => handleNavigate(`/tabellaporanproduksi`, "Laporan Produksi")}
            path="/"
          /> */}
          
          <SidebarItem
              isCollapsed={isCollapsed} // Use collapse state on desktop
              icon={<LaporanProduksiIcon className="h-6 w-6" />}
              label="Rencana dan Laporan Produksi"
              isSelected={selectedItem === "Rencana dan Laporan Produksi"}
              onClick={() => {handleNavigate(`/tabeljadwalcustomer`, "Rencana dan Laporan Produksi");
                isMobileOpen && toggleMobileSidebar();}}
              // onClick={() => handleNavigate(`/tabeljadwalcustomer`, "Jadwal Produksi")}
              path="/"
            />
          
            <SidebarItem
              isCollapsed={isCollapsed} // Use collapse state on desktop
              icon={<LaporanProduksiIcon className="h-6 w-6" />}
              label="Laporan Periodik"
              isSelected={selectedItem === "Laporan Periodik"}
              onClick={() => {handleNavigate(`/weeklyreports`, "Laporan Periodik");
                isMobileOpen && toggleMobileSidebar();}}
              path="/"
            />
            <SidebarItem
                isCollapsed={isCollapsed} // Use collapse state on desktop
                icon={<StarIcon className="h-6 w-6" />}
                label="Rating Penerima Manfaat"
                isSelected={selectedItem === "Rating Penerima Manfaat"}
                onClick={() => {handleNavigate(`/ratingpelanggan`, "Rating Penerima Manfaat");
                  isMobileOpen && toggleMobileSidebar();}}
                // onClick={() => handleNavigate(`/tabeljadwalcustomer`, "Jadwal Produksi")}
                path="/"
              />
          
            <SidebarItem
                isCollapsed={isCollapsed} // Use collapse state on desktop
                icon={<PlusIcon className="h-5 w-5" />}
                label="Order Manual"
                isSelected={selectedItem === "Order Manual"}
                onClick={() => {handleNavigate(`/ordertambahan`, "Order Manual");
                  isMobileOpen && toggleMobileSidebar();}}
                // onClick={() => handleNavigate(`/tabeljadwalcustomer`, "Jadwal Produksi")}
                path="/"
              />
          {/* <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<PenerimaanBahan className="h-6 w-6" />}
            label="Penerimaan Bahan"
            isSelected={selectedItem === "Penerimaan Bahan"}
            onClick={() => {handleNavigate(`/daftarPO`, "Penerimaan Bahan");
              isMobileOpen && toggleMobileSidebar();}}
            // onClick={() => handleNavigate(`/penerimaanbahanDapur?startDate=${localDateString(today)}&endDate=${localDateString(today)}`, "Penerimaan Bahan")}
            path="/"
          /> */}
          
          </div>
            ): ""
          ) }
           {roleId === 3 ? (
            <div>
          
            <SidebarItem
                isCollapsed={isCollapsed} // Use collapse state on desktop
                icon={<StockIcon className="h-6 w-6" />}
                label="Stok"
                isSelected={selectedItem === "Stok"}
                onClick={(path, label) => {
                  handleNavigate(path, label);
                  if (isMobileOpen) toggleMobileSidebar();
                }}
                path="/"
                subItems={[
                  { label: "Stok Bahan Baku", path: "/daftarStock/" },
                  // { label: "Stock Dapur", path: "/daftarStockDapur/" }
                ]}
              />
                
            </div>
        ) : ( "" )}
        </div>

        {/* Bottom Section */}
        {/* <div className="mt-10 text-gray-500">
          <SidebarItem
            isCollapsed={isCollapsed} // Use collapse state on desktop
            icon={<PengaturanIcon className="h-6 w-6" />}
            label="Pengaturan"
            isSelected={selectedItem === "Pengaturan"}
            onClick={() => handleNavigate("/settings", "Pengaturan")}
            path="/settings"
          />
        </div> */}
      </div>

      {/* Overlay for Mobile View */}
      {isMobileOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-10 md:hidden sm:hidden"
          onClick={toggleMobileSidebar}
        ></div>
      )}
    </div>
  );
}



function SidebarItem({ icon, label, isCollapsed, isSelected, onClick, subItems, path }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();

  const toggleExpansion = () => {
    setIsExpanded((prev) => !prev);
  };

  const isSubItemSelected = (subItemPath, matchPaths) => {
    const currentPath = location.pathname.split('?')[0];
    const matchList = matchPaths || [subItemPath];
    return matchList.some((matchPath) => currentPath === matchPath);
  };
  
  const isMainItemSelected = isSelected || (subItems && subItems.some((subItem) => isSubItemSelected(subItem.path)));

  return (
    <div className="relative group">
      {/* Main Item */}
      <a
        href={path || "#"} // Use the main path if provided
        className={`flex items-center p-2 my-3 rounded-md cursor-pointer transition-all duration-300 text-xs hover:text-white ${
          isMainItemSelected ? "text-merah-hover" : "text-gray-500"
        } hover:bg-[#FFA101] ${isCollapsed ? "justify-center" : ""}`}
        onClick={(e) => {
          e.preventDefault(); // Prevent default navigation
          subItems ? toggleExpansion() : onClick(path, label); // Conditional behavior
        }}
        target={subItems ? "_self" : "_blank"} // Open sub-items in the same tab
        rel="noreferrer"
      >
        <div>{icon}</div>
        {!isCollapsed && (
          <span className="ml-4">{label}</span>
        )}
        {!isCollapsed && subItems && (
          <span className={`ml-auto ${isExpanded ? "rotate-90" : ""}`}>▶</span>
        )}
      </a>

      {/* Sub-Items for Expanded Sidebar */}
      {!isCollapsed && isExpanded && subItems && (
        <div
          className={`overflow-hidden transition-all duration-300 ease-in-out ${
            isExpanded ? "max-h-[500px] opacity-100 scale-100" : "max-h-0 opacity-0 scale-95"
          }`}
          style={{
            maxHeight: isExpanded ? `${subItems.length * 40}px` : "0",
          }}
        >
          {subItems.map((subItem, index) => (
            <a
              key={index}
              href={subItem.path}
              className={`flex pl-6 text-sm cursor-pointer py-1 transition-all duration-300 rounded-md ${
                isSubItemSelected(subItem.path, subItem.matchPaths)
                  ? "text-black text-xs rounded-[10px] hover:text-white hover:bg-[#FFA101]"
                  : "text-gray-500 hover:text-white hover:bg-[#FFA101] text-xs rounded-[10px]"
              }`}
              onClick={(e) => {
                e.preventDefault(); // Prevent default link behavior
                onClick(subItem.path, subItem.label); // Trigger navigation
              }}
            >
              {subItem.label}
            </a>
          ))}
        </div>
      )}

      {/* Floating Sub-Items for Collapsed Sidebar */}
      {isCollapsed && subItems && (
        <div className="absolute left-full top-0 w-max bg-white shadow-lg rounded-md opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-all duration-300">
          {subItems.map((subItem, index) => (
            <a
              key={index}
              href={subItem.path}
              className={`flex px-4 py-2 text-sm cursor-pointer transition-all duration-300 rounded-md ${
                isSubItemSelected(subItem.path, subItem.matchPaths)
                  ? "text-black text-xs rounded-[10px] hover:text-white hover:bg-[#FFA101]"
                  : "text-gray-500 hover:text-white hover:bg-[#FFA101] text-xs rounded-[10px]"
              }`}
              onClick={(e) => {
                e.preventDefault(); // Prevent default navigation
                onClick(subItem.path, subItem.label); // Trigger the click handler
              }}
            >
              {subItem.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}


